import React, { useMemo } from 'react';
import Page from '../../Settings/Components/SettingsPage';
import ActionsContainer from '../../../components/ActionsContainer/ActionsContainer';
import EnvironmentMenu from '../../../components/EnvironmentMenu/EnvironmentMenu';
import ThemeButton from '../../../components/ThemeButton/ThemeButton';
import EndpointSettingsTable, {
  EndpointSettingsTableMode,
} from './EndpointSettingsTable';
import {
  MutedTitleComponent,
  UnmonitoredTitleComponent,
} from './EndpointSettingsTableTitle';
import useHeadsUpSettingsQuery from '../../../hooks/useHeadsUpSettingsQuery';
import useEnvironment from '../../../hooks/useEnvironment';

export default function HeadsUpSettingsPage() {
  const { environment } = useEnvironment();

  const endpointSettingsQuery = useHeadsUpSettingsQuery({
    environmentName: environment?.name,
  });

  const [mutedEndpoints, unmonitoredEndpoints] = useMemo(() => {
    const data = endpointSettingsQuery.data ?? [];

    const mutedEndpoints = data.filter((endpoint) => endpoint.isMuted);
    const unmonitoredEndpoints = data.filter((endpoint) => endpoint.isDetectionExcluded);

    return [mutedEndpoints, unmonitoredEndpoints];
  }, [endpointSettingsQuery.data]);

  if (endpointSettingsQuery.isError) {
    return (
      <Page
        actions={
          <ActionsContainer>
            <EnvironmentMenu />
            <ThemeButton />
          </ActionsContainer>
        }
      >
        <h2>Heads Up Settings</h2>
        <div>Failed to load settings list</div>
      </Page>
    );
  }

  return (
    <Page
      className="headsUpSettingsPage"
      actions={
        <ActionsContainer>
          <EnvironmentMenu />
          <ThemeButton />
        </ActionsContainer>
      }
    >
      <h2>Heads Up Settings</h2>
      <EndpointSettingsTable
        titleComponent={MutedTitleComponent}
        endpoints={mutedEndpoints}
        loading={endpointSettingsQuery.isLoading}
        tableMode={EndpointSettingsTableMode.Muted}
      />

      <EndpointSettingsTable
        titleComponent={UnmonitoredTitleComponent}
        endpoints={unmonitoredEndpoints}
        loading={endpointSettingsQuery.isLoading}
        tableMode={EndpointSettingsTableMode.Unmonitored}
      />
    </Page>
  );
}
